import React, { Fragment, useEffect, useState, useRef } from 'react';
import { Edit, PlusCircle, XCircle } from 'react-feather';
import { useSelector } from 'react-redux';
import { Modal, ModalBody, ModalFooter, ModalHeader, Row, Col, Button, Label, Input, Tooltip } from 'reactstrap';
import { Avatar, Steps } from 'antd';
import { notificationMsg } from '../../../utility/Notification';
import { getAllSkills } from '../../../redux/actions/skills.action';
import {
  createNewMilestone,
  getProjects,
  getUserDetail,
  updateMilstone,
  updateStatusChanged,
  saveQBCustomers,
} from '../../../redux/actions/projects.actions';
import {
  getProjectManagers,
  getEmployeeLeaves,
  getEmployeeByIdHome,
  getEmployeeLeavesHR,
  updateLeaveType,
  getAllDeletedLeavesForHr,
  getSystemGeneratedLeavesForHr,
  getAllSystemDeletedLeavesForHr,
} from '../../../redux/actions/user.action';
import TextAreaComponent from '../../Home/list/components/TextAreaComponent';
import saveChanges from './SaveData';
import { updateDomain } from '../../../redux/actions/emailMarketingDomains';
import ResourceRemarksComponent from './ResourceRemarksComponent';
import WarningModal from '../../../components/WarningModal';
import dayjs from 'dayjs';
import Select from '../../../components/Select/Select';
import axios from '../../../services/httpService';
import { BILLING_FREQUENCY, DEFAULT_HTTP_ERROR } from '../../../constants/common';
import { useLocation } from 'react-router-dom';
import CommonModal from '../../../components/CommonModal';
import { BillingDetails } from '../../ProjectOnBoarding/Components/BillingDetails';
import { addNew, handleRemove } from '../../ProjectPortfolio/Components/CommonFunctions';
import { addProjectBillings } from '../../../redux/actions/onBoardProject.action';
import { DatePicker } from 'antd';
import { ActionButtons } from '../../../components/ActionButtons/ActionButtons';
import { capitalizeEachFirstLetter } from '../../../utility/Utils';
import { UPDATE_PROJECT_OPTIMISTIC } from '../../../redux/actions/Types';

//---------------- custom hide/unhide columns styling --------
export const customHideunhideStyles = {
  control: (provided, state) => ({
    ...provided,
    border: 'none',
    display: 'none',
    width: 0,
  }),
  singleValue: (provided) => ({
    ...provided,
    color: themeMode === 'light' ? 'black' : 'white',
  }),
  menuList: (base) => ({
    ...base,
    padding: 0,
    background: themeMode === 'light' ? 'dark' : '#051A38',
  }),
  option: (base, { data, isDisabled, isFocused, isSelected }) => ({
    ...base,
    display: 'flex',
    alignItems: 'center',
    columnGap: '2px',
    backgroundColor: isSelected && isFocused ? (themeMode === 'dark' ? '#1A5ECC' : '#E9F1FF') : undefined,
    backgroundColor: isDisabled && themeMode === 'dark' ? undefined : '',
    color: themeMode === 'dark' ? 'white' : 'hsl(0, 0%, 50%)',
    borderLeft: themeMode === 'dark' ? '2px solid #051A38' : 'none',
    borderRight: themeMode === 'dark' ? '2px solid #051A38' : 'none',
    '&:hover': {
      backgroundColor: isDisabled ? undefined : isFocused ? (themeMode === 'dark' ? '#3498db' : '#c6e2ff') : undefined,
    },
  }),
  input: (provided) => ({
    ...provided,
    color: themeMode === 'light' ? 'black' : 'white',
  }),
  container: (base) => ({
    ...base,
    width: '13% !important',
    minWidth: '160px',
    float: 'right !important',
  }),
  menuPortal: (base) => ({ ...base, zIndex: 99999 }),
  placeholder: (defaultStyles) => {
    return {
      ...defaultStyles,
      color: '#7F8A9B',
      fontSize: '11px',
      fontWeight: '500',
    };
  },
  valueContainer: (base) => ({
    ...base,
    maxHeight: '100px',
    overflowY: 'auto !important',
  }),
};

// ---------------- custom select styling ----------
export const customStyles = {
  control: (provided, state) => ({
    ...provided,
    border: state.isFocused ? '1px solid #2176FF' : themeMode === 'light' ? '1px solid  #98A0AE' : '1px solid #FFFFFF',
    boxShadow: state.isFocused ? '0px 0px 1px #2176FF' : 'none',
    background: themeMode === 'light' ? 'white' : '#051A38',
  }),
  singleValue: (provided) => ({
    ...provided,
    color: themeMode === 'light' ? 'black' : 'white',
  }),
  menuList: (base) => ({
    ...base,
    padding: 0,
    background: themeMode === 'light' ? 'dark' : '#051A38',
  }),
  option: (styles, state) => ({
    ...styles,
    backgroundColor: state.isFocused ? (themeMode === 'dark' ? '#3498db' : '#c6e2ff') : undefined,
    color: state.isSelected ? (themeMode === 'light' ? 'black' : 'white') : themeMode === 'light' ? '#666c75' : 'white',
    borderLeft: themeMode === 'dark' ? '2px solid #051A38' : 'none',
    borderRight: themeMode === 'dark' ? '2px solid #051A38' : 'none',
    '&:hover': {
      ...styles,
      backgroundColor: state.isDisabled ? undefined : state.isFocused ? (themeMode === 'dark' ? '#3498db' : '#c6e2ff') : undefined,
      color: themeMode === 'light' ? 'black' : 'white',
    },
  }),
  input: (provided) => ({
    ...provided,
    color: themeMode === 'light' ? 'black' : 'white',
  }),
  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  menu: (base) => ({ ...base, zIndex: 99 }),
  placeholder: (defaultStyles) => {
    return {
      ...defaultStyles,
      color: '#7F8A9B',
      fontSize: '12px',
      fontWeight: '500',
    };
  },
  valueContainer: (base) => ({
    ...base,
    height: 38,
    overflow: 'auto',
  }),
};

// ---------------- custom select styling ----------
export const customStylesForDifferentSize = {
  control: (provided, state) => ({
    ...provided,
    border: state.isFocused ? '1px solid #2176FF' : themeMode === 'light' ? '1px solid  #98A0AE' : '1px solid #FFFFFF',
    boxShadow: state.isFocused ? '0px 0px 1px #2176FF' : 'none',
    background: themeMode === 'light' ? 'white' : '#051A38',
    width: '242px',
    '@media (max-width: 940px)': {
      width: '100%',
    },
  }),
  singleValue: (provided) => ({
    ...provided,
    color: themeMode === 'light' ? 'black' : 'white',
  }),
  menuList: (base) => ({
    ...base,
    padding: 0,
    background: themeMode === 'light' ? 'dark' : '#051A38',
  }),
  option: (styles, state) => ({
    ...styles,
    backgroundColor: state.isFocused ? (themeMode === 'dark' ? '#3498db' : '#c6e2ff') : undefined,
    color: state.isSelected ? (themeMode === 'light' ? 'black' : 'white') : themeMode === 'light' ? '#666c75' : 'white',
    borderLeft: themeMode === 'dark' ? '2px solid #051A38' : 'none',
    borderRight: themeMode === 'dark' ? '2px solid #051A38' : 'none',
    '&:hover': {
      ...styles,
      backgroundColor: state.isDisabled ? undefined : state.isFocused ? (themeMode === 'dark' ? '#3498db' : '#c6e2ff') : undefined,
      color: themeMode === 'light' ? 'black' : 'white',
    },
  }),
  input: (provided) => ({
    ...provided,
    color: themeMode === 'light' ? 'black' : 'white',
  }),
  menuPortal: (base) => ({ ...base, zIndex: 999999999 }),
  menu: (base) => ({ ...base, zIndex: 99 }),
  placeholder: (defaultStyles) => {
    return {
      ...defaultStyles,
      color: '#6e6b7b',
      fontSize: '12px',
      fontWeight: '500',
    };
  },
  valueContainer: (base) => ({
    ...base,
    height: 36,
    overflow: 'auto',
  }),
};

// -------------- common select component ------------
export const SelectComponent = (props) => {
  const selectRef = useRef(null);
  const refSelectContainer = useRef(null);
  const selectInputRefss = useRef();
  const { Step } = Steps;
  const {
    skillName,
    adminSkillsPermission,
    row,
    value,
    label,
    options,
    type,
    flag,
    theme,
    dispatch,
    roles,
    homePermission,
    selectFlag,
    setColorFlag,
    sortBy,
    sortingOrder,
    trailingOptions,
    selectedOption,
    setUpdating,
  } = props;
  const { employee: userPermission } = useSelector((state) => state.userPermissions);
  const themeMode = useSelector((state) => state.layout.themeMode);
  const projects = useSelector((state) => state.projects);
  const portfolios = useSelector((state) => state.portfolio.portfolio);
  const projectManagersDrop = useSelector((state) => state.users.projectManagers);
  const skillsList = useSelector((state) => state.users.skillsList);
  const [editable, setEditable] = useState(false);
  const [option, setOption] = useState({ value, label });
  const [reason, setReason] = useState('');
  const [hover, setHover] = useState(false);
  const [deleteLim, setDeleteLim] = useState(false);
  const [userWritePermission, setUserWritePermission] = useState({
    read: true,
    write: true,
  });
  const current_user = useSelector((state) => state?.userPermissions?.employee);
  const projectManagerRole = projects?.roles.find((role) => role.name.toLowerCase() === 'project manager');
  const bdRole = roles?.find((el) => {
    return el?.name?.toLowerCase() === 'key account handler';
  });
  const [selectedTechnology, setSelectedTechnology] = useState([]);
  const [deleteModalFlag, setDeleteModalFlag] = useState(false);
  const [employeeProjectInfo, setEmployeeProjectInfo] = useState({});
  const [openDel, setOpenDel] = useState(false);
  const [removedWithInWeek, setRemovedWithInWeek] = useState(false);
  const [skills, setSkills] = useState([]);
  const [alPms, setAlPms] = useState([]);
  const [reporting, setReporting] = useState('');
  const [communication, setCommunication] = useState();
  const [quality, setQuality] = useState();
  const [reasonOfDetachment, setReasonOfDetachment] = useState();
  const [rating, setRating] = useState(null);
  const [projectManagerId, setProjectManagerId] = useState(null);
  const [isDeleteLoading, setIsDeleteLoading] = useState(false);
  const [workQuality, setWorkQuality] = useState();
  const location = useLocation();
  const projectManagers = useSelector((state) => state.onBoardingProject.onBoardingProjects.project_managers);
  const [pmOptions, setPmOptions] = useState([]);
  const [links, setLinks] = useState([]);
  const [linksCount, setLinksCount] = useState(0);
  const [selectedRow, setSelectedRow] = useState(null);
  const ref = useRef(null);
  const [stepper, setStepper] = useState(null);

  const billingChannels = useSelector((state) => state?.billingChannelReducer?.allBillingChannels);
  const onBoardProjectBillingData = {
    onBoardingId: row?.id,
    startDate: null,
    clientCompanyName: null,
    clientName: null,
    exactClientName: null,
    clientEmail: null,
    clientCompanyAddress: null,
    billingFrequency: null,
    currency: 'United States Dollar',
    currencyOther: null,
    totalEstimatedHours: null,
    projectCost: null,
    PMAssigned: null,
    billingPlateform: null,
    country: null,
  };
  const [projectBillingData, setProjectBillingData] = useState(null);
  const formattedDateStart = projectBillingData?.startDate ? new Date(projectBillingData.startDate).toISOString().split('T')[0] : null;

  const defaultPMAssigned = projectBillingData?.PMAssigned && pmOptions && pmOptions?.find((el) => el.value === projectBillingData.PMAssigned);
  const [isDisabled, setIsDisabled] = useState(true);
  const [loader, setLoader] = useState(false);
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [milestonesModal, setMilestonesModal] = useState(false);
  const [statusReasonsModal, setStatusReasonsModal] = useState(false);
  const [closeReason, setCloseReason] = useState(null);
  const [updatingRows, setUpdatingRows] = useState({});
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const [addMilestones, setAddMilestones] = useState([{ description: '', dueDate: null, amount: '' }]);
  const milestonesDisabled = addMilestones?.some((item) => !item.description || !item.dueDate || !item.amount);

  const [currentStepIndex, setCurrentStepIndex] = useState(0);
  const isFixedGig = projectBillingData?.augmentation === 'FIXED_GIGZ';

  const STEP_ONBOARD = 0;
  const STEP_BILLING = 1;
  const STEP_MILESTONES = 2;

  const toggleTooltip = () => {
    setTooltipOpen(!tooltipOpen);
  };

  const setRowUpdating = (rowId, isUpdating) => {
    setUpdatingRows((prev) => ({ ...prev, [rowId]: isUpdating }));
  };

  useEffect(() => {
    setSelectedRow(row);
  }, [row]);

  const defaultBillingFrequency =
    BILLING_FREQUENCY &&
    BILLING_FREQUENCY.find((el) => {
      if (row?.augmentation || row?.engagement === 'FIXED_GIGZ') {
        return el.value === 'MILESTONE';
      }
      return el.value === row?.billingFrequency || el.value === row?.augmentation;
    });

  const validateFormDataFirstStep = (formData) => {
    let requiredFields = [
      // 'projectCost',
      'startDate',
      'PMAssigned',
    ];

    // Check if any required field is missing or errors exist
    const isDisabled = requiredFields?.some((field) => {
      return formData && !formData[field];
    });
    return isDisabled;
  };

  const validateFormDataSecondStep = (formData) => {
    let requiredFields = [
      'country',
      'clientCompanyName',
      'augmentation',
      // 'billingStartDate',
      'currency',
      'billingPlateform',
      'exactClientName',
    ];
    // Custom conditions
    if (formData?.currency === 'Other') {
      requiredFields?.push('currencyOther');
    }

    if (formData?.augmentation === 'FIXED_GIGZ') {
      requiredFields?.push('totalEstimatedHours');
    }

    if (formData && ['UPWORK_PROFILE', 'PAYONEER_ACCOUNT', 'OTHER'].includes(formData['billingPlateform'])) {
      requiredFields?.push('billingProfile');
    }

    // Check if any required field is missing or errors exist
    const isDisabled = requiredFields?.some((field) => {
      return formData && !formData[field];
    });
    return isDisabled;
  };
  const validateFormData = (formData) => {
    let requiredFields = [
      'country',
      'clientCompanyName',
      'augmentation',
      'currency',
      // 'projectCost',
      'startDate',
      'PMAssigned',
      'billingPlateform',
      'exactClientName',
    ];
    // Custom conditions
    if (formData?.currency === 'Other') {
      requiredFields?.push('currencyOther');
    }

    if (formData?.augmentation === 'FIXED_GIGZ') {
      requiredFields?.push('totalEstimatedHours');
    }

    if (formData && ['UPWORK_PROFILE', 'PAYONEER_ACCOUNT', 'OTHER'].includes(formData['billingPlateform'])) {
      requiredFields?.push('billingProfile');
    }

    // Check if any required field is missing or errors exist
    const isDisabled = requiredFields?.some((field) => {
      return formData && !formData[field];
    });
    return isDisabled;
  };

  // ------------- Handler for status change reason
  const handleStatusReason = (e) => {
    dispatch(updateStatusChanged(selectedRow?.id, selectedRow?.status, location?.pathname, closeReason));
  };

  const handleManageChannel = async () => {
    setLoader(true);
    let billingChannelId;
    if (projectBillingData?.billingPlateform) {
      billingChannelId = billingChannels?.find((item) => item?.slug === projectBillingData?.billingPlateform)?.id;
    }
    const body = {
      PMAssigned: projectBillingData?.PMAssigned,
      engagement: projectBillingData?.augmentation,
      billingCycle: projectBillingData?.billingFrequency,
      // billingChannel: projectBillingData?.billingPlateform,
      billingChannelId,
      billingProfile: projectBillingData?.billingProfile,
      clientCompanyName: projectBillingData?.clientCompanyName,
      country: projectBillingData?.country,
      currency: projectBillingData?.currency,
      currencyOther: projectBillingData?.currencyOther,
      totalEstimatedHours: projectBillingData?.totalEstimatedHours,
      projectId: selectedRow?.id,
      projectCost: projectBillingData?.projectCost,
      startDate: projectBillingData?.startDate,
      exactClientName: projectBillingData?.exactClientName,
      clientContactPersonName: projectBillingData?.exactClientName,
      status: 'ACTIVE',
      remindersTime: projectBillingData?.remindersTime,
    };

    await dispatch(addProjectBillings(body));
    // Update status only for non-fixed gigs projects
    await saveChanges(location?.pathname, selectedRow?.id, 'status', 'ACTIVE', null, null, dispatch, roles, null);
    if (currentStepIndex === STEP_BILLING) {
      dispatch(getProjects());
    }
    setSelectedRow(null);
    setConfirmationModal(false);
    setLoader(false);
    setProjectBillingData(null);
    setCurrentStepIndex(0);
  };

  const handleMilestones = async () => {
    setLoader(true);
    const newMilestones = addMilestones?.map((item) => ({
      description: item.description,
      dueDate: item.dueDate,
      amount: item.amount,
    }));
    const body = {
      projectId: selectedRow?.id,
      newMilestones,
    };

    await dispatch(createNewMilestone(body));
    // Refresh projects to show newly created milestones
    await dispatch(getProjects());
    if (milestonesModal) {
      setMilestonesModal(false);
    }
    if (type === 'engagement') {
      await saveChanges(location?.pathname, selectedRow?.id, type, option?.value, null, null, dispatch, roles, null);
    }
    setConfirmationModal(false);
    setLoader(false);
    setAddMilestones([{ description: '', dueDate: '', amount: '' }]);
    setSelectedRow(null);
    setProjectBillingData(null);
  };

  useEffect(() => {
    const PMOptions = projectManagersDrop?.map((pm) => {
      return {
        value: pm.id,
        label: pm.name,
      };
    });
    setPmOptions(PMOptions);
  }, [projectManagersDrop]);

  const selectPmHandler = (selectedOption) => {
    if (selectedOption) {
      // setPmValues(selectedOption);
      setProjectBillingData((prevFormData) => ({
        ...prevFormData,
        PMAssigned: selectedOption?.value,
        onBoardingId: selectedRow?.id,
      }));
    }
  };

  const getTotalAmount = (links) => {
    let total = 0;

    links.forEach((link) => {
      const parsedAmount = parseInt(link.amount);
      total += isNaN(parsedAmount) ? 0 : parsedAmount;
    });

    return total;
  };
  const hourOptions = [
    { label: 'Pause', value: 'pause' },
    ...Array.from({ length: 24 }, (_, i) => {
      const value = i.toString().padStart(1, '0');
      return { value, label: `${value}:00` };
    }),
  ];

  const bodyEditSubModal = () => {
    return (
      <>
        <Label className="spanSteric">
          Note: We need to verify the billing details before making it active. Even if you recently updated them, we want to confirm if anytthing has
          changed.
        </Label>
        <Row className="row-projects">
          <Col xs="6">
            <Label>
              Project Manager <span className="spanSteric">*</span>
            </Label>
            <Select
              placeholder="Select Project Manager"
              options={pmOptions}
              maxMenuHeight={150}
              onChange={selectPmHandler}
              value={defaultPMAssigned}
            />
          </Col>
          <Col xs="6">
            <Label>
              Start Date <span className="spanSteric">*</span>
            </Label>
            <DatePicker
              className="ant-datePicker-wrapper form-control"
              name="startDate"
              format="YYYY-MM-DD"
              placeholder="Select Date"
              value={formattedDateStart ? dayjs(formattedDateStart, 'YYYY-MM-DD') : null}
              onChange={(date, dateString) => {
                setProjectBillingData({ ...projectBillingData, startDate: dateString });
              }}
            />
          </Col>
        </Row>

        <Row className="row-projects">
          <Col xs="6">
            <Label>
              Day Start Reminder <span className="spanSteric">*</span>
            </Label>
            <Select
              placeholder="Select Start Time"
              options={hourOptions}
              value={hourOptions.find((opt) => opt.value === projectBillingData?.remindersTime?.dayStart.toString())}
              onChange={(selected) => {
                setProjectBillingData({
                  ...projectBillingData,
                  remindersTime: {
                    ...projectBillingData.remindersTime,
                    dayStart: selected.value,
                  },
                });
              }}
            />
          </Col>

          <Col xs="6">
            <Label>
              Day End Reminder <span className="spanSteric">*</span>
            </Label>
            <Select
              placeholder="Select End Time"
              options={hourOptions}
              value={hourOptions.find((opt) => opt.value === projectBillingData?.remindersTime?.dayEnd.toString())}
              onChange={(selected) => {
                setProjectBillingData({
                  ...projectBillingData,
                  remindersTime: {
                    ...projectBillingData.remindersTime,
                    dayEnd: selected.value,
                  },
                });
              }}
            />
          </Col>
        </Row>
      </>
    );
  };

  const closeOptions = [
    { label: 'Client went unresponsive', value: 'Client went unresponsive' },
    { label: 'Slow handling from our side', value: 'Slow handling from our side' },
    { label: 'We don’t have the right skills', value: 'We don’t have the right skills' },
    { label: 'Client didn’t like the budget', value: 'Client didn’t like the budget' },
    { label: 'Client didn’t like our skills', value: 'Client didn’t like our skills' },
    { label: 'Couldn’t meet client’s requirements', value: 'Couldn’t meet client’s requirements' },
    { label: 'Changes in client’s priorities', value: 'Changes in client’s priorities' },
    { label: 'Client hired someone else', value: 'Client hired someone else' },
    { label: 'We don’t like the client’s behavior', value: 'We don’t like the client’s behavior' },
    { label: 'Some other reason', value: 'Some other reason' },
  ];

  const closeReasons = [
    { label: 'Project delivered successfully', value: 'Project delivered successfully' },
    { label: 'Client ran into budget issues', value: 'Client ran into budget issues' },
    { label: 'Client went unresponsive', value: 'Client went unresponsive' },
    { label: 'Couldn’t meet client’s expectations', value: 'Couldn’t meet client’s expectations' },
    { label: 'We ran into a dispute or a conflict with the client', value: 'We ran into a dispute or a conflict with the client' },
  ];

  // ------------- Modal Body for selecting the reason to close the project
  const bodyStatusReasonModal = () => {
    return (
      <>
        <div>
          <h5 style={{ marginTop: '1rem' }}>Are you sure you want to close this project ?</h5>
          <Select
            options={row?.status === 'PRESALE' ? closeOptions : closeReasons}
            placeholder={'Select Reason'}
            onChange={(event) => {
              if (event && event?.value) {
                const { label, value } = event;
                setCloseReason(value);
              }
            }}
            maxMenuHeight={120}
          />
        </div>
      </>
    );
  };

  // ------------- Close the modal on close button click
  const handleClose = () => {
    setConfirmationModal(false);
    setMilestonesModal(false);
    setStatusReasonsModal(false);
    setOption({ value: '', label });
    setAddMilestones([{ description: '', dueDate: '', amount: '' }]);
    setSelectedRow(null);
    setProjectBillingData(null);
    setCloseReason(null);
    setCurrentStepIndex(0);
  };
  const footerEditSubModal = () => {
    return (
      <>
        <div className="d-flex mr-0">
          <Button
            outline
            style={{ marginRight: '10px', cursor: selectedRow?.engagement === 'FIXED_GIGZ' ? 'not-allowed' : '' }}
            onClick={handleClose}
          >
            Cancel
          </Button>
          {statusReasonsModal ? (
            <Button
              color="success"
              disabled={!closeReason || loader}
              onClick={() => {
                setLoader(true);
                handleStatusReason();
                setLoader(false);
                setStatusReasonsModal(false);
              }}
            >
              Close Project
            </Button>
          ) : (
            <Button color="success" disabled={milestonesDisabled || loader} onClick={handleMilestones}>
              {loader ? 'Loading...' : 'Add Milestones'}
            </Button>
          )}
        </div>
      </>
    );
  };

  const handleNext = () => {
    if (currentStepIndex < steps?.length - 1) {
      setCurrentStepIndex((prev) => prev + 1);
    }
  };

  const handleBack = () => {
    if (currentStepIndex > 0) {
      setCurrentStepIndex((prev) => prev - 1);
    }
  };
  const wizardFooterEditSubModal = () => {
    const isLastStep = steps?.length > 0 && currentStepIndex === steps?.length - 1;
    const isSingleStep = steps.length === 1;

    return (
      <div className="d-flex mr-0">
        {currentStepIndex === STEP_ONBOARD && (
          <Button outline style={{ marginRight: '10px' }} onClick={handleClose}>
            Cancel
          </Button>
        )}
        {/* Back Button on last step as well, if needed */}
        {!isSingleStep && currentStepIndex > STEP_ONBOARD && (
          <Button outline style={{ marginRight: '10px' }} onClick={handleBack}>
            Back
          </Button>
        )}
        {/* Single step: Add Billings submits and closes */}
        {isLastStep && currentStepIndex === STEP_BILLING && (
          <Button color="success" disabled={validateFormDataSecondStep(projectBillingData) || loader} onClick={handleManageChannel}>
            {loader ? 'Loading...' : 'Activate Project'}
          </Button>
        )}
        {/* Multi-step: First step button saves and moves to next step */}
        {currentStepIndex < steps?.length - 1 && (
          <Button
            color="primary"
            disabled={
              (currentStepIndex === STEP_ONBOARD && validateFormDataFirstStep(projectBillingData)) ||
              (currentStepIndex === STEP_BILLING && validateFormDataSecondStep(projectBillingData)) ||
              loader
            }
            onClick={handleNext}
          >
            Next
          </Button>
        )}
        {/* Multi-step: Last step button saves milestones and closes */}
        {isLastStep && currentStepIndex === STEP_MILESTONES && (
          <Button
            color="success"
            disabled={milestonesDisabled || loader}
            onClick={async () => {
              await handleMilestones();
              await handleManageChannel();
            }}
          >
            {loader ? 'Loading...' : 'Activate Project'}
          </Button>
        )}
      </div>
    );
  };
  const handleChange = (value, field, milestoneIndex) => {
    const updatedMilestones = addMilestones?.map((milestone, index) => {
      if (index === milestoneIndex) {
        return {
          ...milestone,
          [field]: value,
        };
      }
      return milestone;
    });
    setAddMilestones(updatedMilestones);
  };

  // Add multiple milestones
  const handleAddNewMilestone = () => {
    setAddMilestones((prev) => {
      return [...prev, { description: '', dueDate: null, amount: '' }];
    });
  };

  // Remove milestone
  const handleRemoveMilestone = (milestoneIndex) => {
    const excludeDeletedMilestone = addMilestones?.filter((_, index) => index !== milestoneIndex);
    setAddMilestones(excludeDeletedMilestone);
  };

  const milestones = () => {
    return (
      <>
        <Row className="d-flex justify-content-end" style={{ marginLeft: '0px', width: '100%' }}>
          <div className="d-flex justify-content-between align-items-center">
            <Label style={{ width: '120px' }}>
              Total Cost: <span className="spanSteric">*</span>
            </Label>
            <Input
              value={getTotalAmount(addMilestones)}
              disabled={true}
              type="text"
              autoComplete="off"
              placeholder={'Type here'}
              maxWidth={'100px'}
            />
          </div>
        </Row>
        {addMilestones?.map((milestone, index) => {
          return (
            <>
              <div>
                <Row className="row-projects" style={{ marginTop: '20px' }}>
                  <Col md="6" xs="12" sm="12">
                    <Label>
                      Milestone description <span className="spanSteric">*</span>
                    </Label>
                    <Input
                      name="exactClientName"
                      type="text"
                      value={milestone.description}
                      maxLength={40}
                      autoComplete="off"
                      placeholder={'Type here'}
                      onChange={(event) => {
                        handleChange(event.target.value, 'description', index);
                      }}
                    />
                  </Col>
                  <Col md="5" xs="12" sm="12">
                    <Row>
                      <Col md="6" sm="6" xs="12">
                        <Label>
                          Due Date <span className="spanSteric">*</span>
                        </Label>
                        <DatePicker
                          className="ant-datePicker-wrapper form-control"
                          name="startDate"
                          autoComplete="off"
                          value={milestone?.dueDate ? dayjs(milestone.dueDate) : null}
                          placeholder="Select Date"
                          onChange={(date, dateString) => {
                            handleChange(dateString, 'dueDate', index);
                          }}
                        />
                      </Col>
                      <Col md="6" sm="6" xs="10">
                        <Label>
                          Deposit Amount <span className="spanSteric">*</span>
                        </Label>
                        <Input
                          name="amount"
                          type="text"
                          value={milestone?.amount}
                          maxLength={10}
                          autoComplete="off"
                          placeholder={'Type here'}
                          onChange={(event) => {
                            handleChange(event.target.value, 'amount', index);
                          }}
                          onKeyPress={(event) => {
                            if (!/[0-9]/.test(event.key)) {
                              event.preventDefault();
                            }
                          }}
                        />
                      </Col>
                    </Row>
                  </Col>
                  <span style={{ marginTop: '25px', marginLeft: '15px' }}>
                    {addMilestones?.length > 1 && (
                      <ActionButtons Delete deleteTooltip={'Delete'} deleteIconSize={25} deleteOnClick={() => handleRemoveMilestone(index)} />
                    )}
                  </span>
                </Row>
              </div>
            </>
          );
        })}
        <div style={{ marginTop: '20px' }}>
          <div
            className="d-flex justify-content-sm-between justify-content-center flex-sm-row flex-column align-items-center"
            style={{ gap: '20px' }}
          >
            <div
              className="d-flex pointer"
              onClick={() => {
                // addNew('bhatti', links, setLinks, linksCount, setLinksCount);
                handleAddNewMilestone();
              }}
            >
              <PlusCircle
                style={{
                  cursor: 'pointer',
                  color: '#1976d2',
                }}
              />
              <span className="ml-50" style={{ color: '#1976d2' }}>
                Add Milestone
              </span>
            </div>
          </div>
        </div>
      </>
    );
  };

  const bodyBillingDetails = () => {
    return (
      <>
        <BillingDetails typeModal={'manage'} formData={projectBillingData} updateFormData={setProjectBillingData}></BillingDetails>
      </>
    );
  };

  const steps = [
    {
      id: 'onBoardingDetails',
      title: 'OnBoarding Details',
      content: bodyEditSubModal(),
    },
    {
      id: 'billingDetails',
      title: 'Billing Details',
      content: bodyBillingDetails(),
    },
    ...(isFixedGig
      ? [
          {
            title: 'Add Milestones',
            content: milestones(),
          },
        ]
      : []),
  ];

  const wizardBody = () => {
    return (
      <div>
        {/* Step Headers */}
        <Row className="mb-2 mt-1">
          {steps.map((step, idx) => {
            const isActive = idx === currentStepIndex;
            return (
              <Col key={idx} className="text-center">
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.5rem',
                    borderBottom: 'none',
                    fontWeight: currentStepIndex === idx ? '600' : '400',
                    color: currentStepIndex === idx ? '#2176ff' : '#6e6b7b',
                  }}
                >
                  <div
                    style={{
                      backgroundColor: isActive ? '#2563eb' : '#575a5f1f', // blue or gray
                      color: isActive ? '#fff' : '#b1b1b1',
                      borderRadius: '6px',
                      width: '40px',
                      height: '40px',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      fontWeight: 600,
                      fontSize: '14px',
                    }}
                  >
                    {idx + 1}
                  </div>
                  <div
                    style={{
                      cursor: 'pointer',
                      fontWeight: currentStepIndex === idx ? 'bold' : 'normal',
                      color: currentStepIndex === idx ? '#2176ff' : theme === 'dark' ? '#fff' : '#929496',
                      whiteSpace: 'none',
                    }}
                  >
                    {step?.title}
                  </div>
                </div>
              </Col>
            );
          })}
        </Row>

        {/* Step Content */}
        <div>{steps[currentStepIndex]?.content}</div>
      </div>
    );
  };

  useEffect(() => {
    if (projectManagersDrop?.length > 0) {
      setAlPms(projectManagersDrop);
      setAlPms((pres) => [...pres, { name: 'N/A', id: null }]);
    }
  }, [projectManagersDrop]);

  useEffect(() => {
    const modifySkillsArrayForDropdown = skillsList?.map((skill) => {
      return {
        value: skill.id,
        label: skill.name,
      };
    });
    setSkills(modifySkillsArrayForDropdown);
  }, [skillsList]);

  useEffect(() => {
    projects?.projects.forEach((el) => {
      if (el?.id === row?.id) {
        el?.Employees &&
          el?.Employees?.find((el) => el?.roleName?.toLowerCase()?.includes('project manager')) &&
          setProjectManagerId(el?.Employees?.find((el) => el?.roleName?.toLowerCase()?.includes('project manager'))?.id);
      }
    });
  }, [projects]);

  useEffect(() => {
    setOption({ value, label });
  }, [row]);

  useEffect(() => {
    if (userPermission.is_admin === true) {
      setUserWritePermission({ read: true, write: true });
    } else if (userPermission?.EmployeePermission && userPermission?.EmployeePermission.permissions) {
      const { permissions } = userPermission?.EmployeePermission;
      setUserWritePermission(permissions.projects);
    }
  }, [userPermission]);

  useEffect(() => {
    if (props.fetchProjectManagers) {
      projectManagersDrop.length < 1 && dispatch(getProjectManagers());
    }
  }, []);

  // Effect to empty milestones if engagement is other than fixed gigz
  useEffect(() => {
    if (projectBillingData?.augmentation !== 'FIXED_GIGZ') {
      setAddMilestones([{ description: '', dueDate: '', amount: '' }]);
    }
  }, [projectBillingData]);

  const addedWithinWeek = (id, employees) => {
    setDeleteModalFlag(false);
    setOpenDel(false);
    if (!id || id === 'N/A' || id === 'null') return false;
    const emp = employees.find((emp) => emp.id == id);
    if (emp) {
      return true;
    } else return false;
  };

  const bdAddedWithinWeek = (id, row) => {
    setDeleteModalFlag(false);
    setOpenDel(false);
    if (!id || id === 'N/A' || id === 'null') return false;
    let addedOn = row.bdEmployee === id;
    if (addedOn) {
      return true;
    } else return false;
  };

  const selectOptions = () => {
    if (type.replace(/_/g, ' ').toLowerCase().includes('key account handler')) {
      const role = roles.find((role) => role?.name.toLowerCase() === 'key account handler');
      const employee = row?.Employees.find((emp) => {
        return emp.EmployeeProject.role_id == role.id;
      });
      return employee ? options?.filter((option) => option.value != employee.id) : options;
    } else if (type.replace(/_/g, ' ').toLowerCase().includes('project manager')) {
      const role = roles.find((role) => role?.name.toLowerCase() === 'project manager');
      const employee = row?.Employees.find((emp) => {
        return emp.EmployeeProject.role_id == role.id;
      });
      return employee ? options?.filter((option) => option.value != employee.id) : options;
    }
    return options.filter((item) => item.value !== value);
  };

  const projectManagerOptions = alPms?.map((manager) => {
    return {
      value: manager.id,
      label: manager.name,
    };
  });

  const deleteProject = async (id, proj_id) => {
    try {
      let role;
      if (type !== 'sales_team') {
        role = roles.find((role) => type?.replace(/_/g, ' ').includes(role?.name?.toLowerCase()));
      } else {
        role = roles.find((role) => role?.name?.toLowerCase() === 'key account handler');
      }
      setIsDeleteLoading(true);
      setUpdating(true);

      const requestBody = {
        employee_id: id,
        project_id: proj_id,
        reason_for_leaving: reasonOfDetachment?.value,
        overallRemarks: !openDel && reason ? reason.trimStart() : null,
        communication: communication,
        quality: quality ? quality : workQuality,
        technologies_id: selectedTechnology?.map((technology) => technology.value),
        codeRatings: rating,
        projectManagerId: location.pathname === '/home' ? localStorage.getItem('loggedInUser') : projectManagerId,
        removedWithinWeek: removedWithInWeek,
        role_id: role?.id,
        reportedBy: current_user?.id,
        ...employeeProjectInfo,
      };

      if (type === 'sales_team') {
        requestBody.isBD = true;
        const isNA = !option.value || option.value === 'N/A' || option.value === 'null';
        const isOldNA = !requestBody.employee_id || requestBody.employee_id === 'N/A' || requestBody.employee_id === 'null';

        if (isNA) {
          await axios.post(`${baseUrl}/project/removeCsmBDEmployee`, requestBody);
          notificationMsg('success', 'Updated successfully.');
        } else if (isOldNA) {
          requestBody.employee_id = option.value;
          requestBody.actionBy = Number(localStorage.getItem('loggedInUser'));
          requestBody.action = 'create';
          await axios.post(`${baseUrl}/project/addCsmBDEmployee`, requestBody);
          notificationMsg('success', 'Updated successfully.');
        } else {
          requestBody.employee_id = id; // Ensuring old ID is used for replacement
          requestBody.new_employee = option.value;
          await axios.post(`${baseUrl}/project/replaceCsmBDEmployee`, requestBody);
          setTimeout(() => {
            notificationMsg('success', 'Updated Successfully.');
          }, 3000);
        }

        const bdMember = projects.non_tech_employees?.find((emp) => emp.id == option.value);

        dispatch({
          type: UPDATE_PROJECT_OPTIMISTIC,
          payload: {
            projectId: proj_id,
            updates: {
              sales_team: option.value,
              bdEmployees: bdMember
                ? {
                    id: bdMember.id,
                    name: bdMember.name,
                    slack_avatar: bdMember.slack_avatar,
                    designation: bdMember.designation,
                  }
                : { id: option.value, name: option.label, slack_avatar: option.slack_avatar },
            },
          },
        });
      } else {
        await axios.post(`${baseUrl}/project/removeEmployee`, requestBody);
      }
      if (location.pathname === '/home') {
        await dispatch(getUserDetail());
      } else {
        // Redacting getProjects() to prevent jumping back to page 1.
        // Optimistic update already handles the real-time UI change.
        // await dispatch(getProjects());
      }
      // Set all states to empty
      openDel && setOpenDel(false);
      setIsDeleteLoading(false);
      setUpdating(false);
      emptyStates();
      setDeleteModalFlag(false);

      if (type !== 'sales_team') {
        handleOk();
      }
    } catch (error) {
      notificationMsg('error', error?.response?.data?.error);
      setIsDeleteLoading(false);
      // setUpdating(false);
      openDel && setOpenDel(false);
    }
  };

  const baseUrl = process.env.REACT_APP_API_URL;

  // Empty all the states of the form
  const emptyStates = () => {
    setReason('');
    setReporting('');
    setRating(null);
    setCommunication();
    setQuality();
    setReasonOfDetachment([]);
    setSelectedTechnology([]);
    setRemovedWithInWeek(false);
    setWorkQuality();
  };

  // Set condition on which user can be deleted
  const canDeleteResource =
    reasonOfDetachment && reason && communication && (quality || workQuality) && selectedTechnology.length > 0 && rating != null && rating != 0;

  const qualityOptions = [
    {
      value: 'Follows Standard Practices',
      label: 'Follows Standard Practices',
    },
    { value: 'Wrote Salvage Code', label: 'Wrote Salvage Code' },
    {
      value: 'Wrote Custom Code but Fair Coding Skills',
      label: 'Wrote Custom Code but Fair Coding Skills',
    },
    {
      value: 'Wrote Custom Code but Weak Coding Skills',
      label: 'Wrote Custom Code but Weak Coding Skills',
    },
  ];

  const reasonDetachmentOptions = [
    { value: 'Project Closure', label: 'Project Closure' },
    { value: 'Requirement Completion', label: 'Requirement Completion' },
    {
      value: 'Client Side Budget Constraints',
      label: 'Client Side Budget Constraints',
    },
    {
      value: 'Performance/Satisfaction Issue',
      label: 'Performance/Satisfaction Issue',
    },
    { value: 'Resource Resigned', label: 'Resource Resigned' },
    {
      value: 'Setting Free for Other Need',
      label: 'Setting Free for Other Need',
    },
  ];

  const selectTechnologyHandler = (value) => {
    setSelectedTechnology(value);
  };

  const selectManagerHandler = (value) => {
    setReporting(value);
  };

  const openMilestonesModal = (row) => {
    if (row) {
      setSelectedRow(row);
    }
    setMilestonesModal(true);
  };

  // -------- update select values ----------
  const updateOption = async (e) => {
    if (type === 'status' && e?.value === 'CLOSED') {
      setSelectedRow({ ...row, status: e?.value });
      setStatusReasonsModal(!statusReasonsModal);

      // Validate the data before proceeding
      const validateData = (data) => {
        if (!data?.name || !data?.status || !data?.engagementModel) {
          return false;
        }
        return true;
      };

      const portfolioByProjectId = portfolios?.find((por) => por.projectId == row.id);
      if (portfolioByProjectId && !validateData(portfolioByProjectId)) {
        return notificationMsg('error', 'Required fields are missing from project portfolio.');
      }
    } else if ((row?.contract === 'INDIVIDUAL_TO_CLIENT' || row?.contract === 'AGENCY_TO_CLIENT') && type === 'status' && e?.value === 'ACTIVE') {
      const billingPlateformFromFormData = billingChannels?.find((item) => item?.id === row?.billingChannelId);
      setSelectedRow({ ...row, status: e?.value });
      setProjectBillingData({
        onBoardingId: row?.id,
        startDate: row?.startDate,
        clientCompanyName: row?.clientCompanyName,
        exactClientName: row?.exactClientName || row?.clientContactPersonName,
        clientName: row?.clientName || row?.clientContactPersonName,
        clientEmail: row?.clientEmail,
        clientCompanyAddress: row?.clientCompanyAddress,
        billingFrequency: row?.billing_cycle?.toUpperCase() || row?.billingFrequency || defaultBillingFrequency?.value,
        augmentation: row?.engagement?.toUpperCase(),
        currency: row?.currency || onBoardProjectBillingData?.currency,
        currencyOther: row?.currencyOther ?? null,
        totalEstimatedHours: row?.totalEstimatedHours ?? null,
        projectCost: row?.projectCost,
        PMAssigned: row?.PMAssigned,
        billingPlateform: billingPlateformFromFormData?.slug,
        // billingPlateform: row?.billingChannel || row?.billingPlateform,
        billingProfile: row?.billingProfile,
        country: row?.country,
        remindersTime: row?.remindersTime || { dayStart: '11', dayEnd: '20' },
      });
      setConfirmationModal(true);
    } else if (type === 'engagement') {
      const old_value = option?.value;
      setOption(e);
      if (e?.value === 'FIXED_GIGZ' && row?.status === 'ACTIVE') {
        openMilestonesModal(row);
      } else {
        setEditable(false);
        saveChanges(location?.pathname, row?.id, type, e?.value, old_value, null, dispatch, roles, null);
      }
    } else if (type === 'status') {
      const old_value = option?.value;
      saveChanges(location?.pathname, row?.id, type, e?.value, old_value, null, dispatch, roles, null);
      setEditable(false);
      setOption(e);
    } else if (type === 'notify_via_email') {
      setEditable(false);
      updateEmailNotification(row.id, e.value);
      setOption(e);
    } else if (location.pathname === '/email-marketing-domains' && type === 'domain_assigned_to') {
      const requestBody = { domain_id: row.id, domainAssignedTo: e.value };
      dispatch(updateDomain(requestBody)).finally(() => {
        notificationMsg('success', 'Domain assigned successfully.');
      });
      setEditable(false);
    } else if (
      (type.location === 'resourceDashboard' && type.leaveCreatedBy === 'DAILY_SHORT_LEAVE') ||
      (type.location === 'hrDashboard' && type.leaveCreatedBy !== 'WEEKLY_SHORT_LEAVE')
    ) {
      const { leaveId, id } = row;
      if (leaveId || id) {
        setOption(e);
        let body = {
          leaveId: type.location === 'hrDashboard' ? leaveId : id,
          leaveType: e.value,
        };
        dispatch(updateLeaveType(body)).finally(() => {
          if (type.location === 'hrDashboard') {
            dispatch(getEmployeeLeavesHR());
            dispatch(getAllDeletedLeavesForHr());
            dispatch(getSystemGeneratedLeavesForHr());
            dispatch(getAllSystemDeletedLeavesForHr());
          } else {
            dispatch(getEmployeeByIdHome(row.employeeId));
            dispatch(getEmployeeLeaves());
          }
        });
      }
    } else {
      if (selectFlag && (e.value === 'INTERNAL_PROJECT' || e.value === 'INTERNAL_TRAINING')) {
        setColorFlag(row.id);
        notificationMsg(
          'error',
          'Please change the resource(s) engagement mode first, Parked, Support and Training are allowed for internal projects.',
        );
      } else if (type === 'sales_team') {
        try {
          const old_id = option?.value;
          const new_id = e?.value;
          const isNA = !new_id || new_id === 'N/A' || new_id === 'null';
          const isOldNA = !old_id || old_id === 'N/A' || old_id === 'null';

          const requestBody = {
            projectManagerId,
            project_id: row.id,
            role_id: bdRole?.id || null,
            location: location.pathname,
            isBD: true,
            reportedBy: current_user?.id,
          };

          if (isNA) {
            requestBody.employee_id = old_id;
            await axios.post(`${baseUrl}/project/removeCsmBDEmployee`, requestBody);
          } else if (isOldNA) {
            requestBody.employee_id = new_id;
            requestBody.actionBy = Number(localStorage.getItem('loggedInUser'));
            requestBody.action = 'create';
            await axios.post(`${baseUrl}/project/addCsmBDEmployee`, requestBody);
          } else {
            requestBody.employee_id = old_id;
            requestBody.new_employee = new_id;
            await axios.post(`${baseUrl}/project/replaceCsmBDEmployee`, requestBody);
          }

          notificationMsg('success', 'Updated successfully.');
          setEditable(false);
          setOption(e);

          // Optimistic update for UI runtime reflection
          dispatch({
            type: UPDATE_PROJECT_OPTIMISTIC,
            payload: {
              projectId: row.id,
              updates: {
                sales_team: e.value,
                bdEmployees: e.value
                  ? {
                      id: e.value,
                      name: e.label,
                      slack_avatar: e.slack_avatar,
                      designation: e.designation,
                    }
                  : null,
              },
            },
          });

          if (location.pathname === '/home') {
            await dispatch(getUserDetail());
          }
        } catch (error) {
          notificationMsg('Error', error.response?.data?.error);
        }
      } else if (type === 'internalChannelId' || type === 'manageChannelId') {
        try {
          const channelType = type === 'internalChannelId' ? 'internalChannelId' : 'manageChannelId';
          await axios.put(`${baseUrl}/project/addChannel`, {
            [channelType]: e.value,
            id: row.id,
          });
          if (e?.value !== null) {
            notificationMsg('success', 'Slack channel added successfully.');
          } else {
            notificationMsg('success', 'Slack channel disconnected successfully.');
          }
          setEditable(false);
          setOption(e);
          if (location.pathname !== '/home') {
            await dispatch(getProjects());
          } else {
            await dispatch(getProjects());
            await dispatch(getProjectManagers());
            await dispatch(getUserDetail());
          }
        } catch (error) {
          notificationMsg('Error', error.response?.data?.error);
        }
      } else if (type === 'quickBookCustomerId') {
        await dispatch(saveQBCustomers(e.value, row.id));
      } else {
        const old_value = option?.value;
        const billingChannelId = type === 'billingChannel' && e?.id;
        const projectById = projects?.projects?.find((pro) => pro?.id == row?.id);
        const pmId = projectById?.Employees?.find((emp) => emp?.EmployeeProject?.role_id == projectManagerRole?.id)?.id;
        setEditable(false);
        if (
          e.value === 'PAYONEER_ACCOUNT' ||
          e.value === 'UPWORK_PROFILE' ||
          e.value === 'DEEL_CONTRACT' ||
          e.value === 'WESTERN_UNION' ||
          e.value === 'OTHER'
        ) {
          let checkBillingProfile = row?.billingProfile;
          if (!checkBillingProfile) {
            setOption({ value: e.value, label: e.label });
            return notificationMsg('error', 'Billing profile is required for this billing channel!!');
          }
        }
        saveChanges(location?.pathname, row?.id, type, e?.value, old_value, null, dispatch, roles, pmId, null, null, billingChannelId);
        setOption?.(e);
      }
    }
  };

  // ---------- updated email notification ------------
  const updateEmailNotification = async (skill_id, notifyViaEmail) => {
    try {
      const response = await axios.put(`/skill/updateEmailNotification`, {
        notifyViaEmail: notifyViaEmail,
        skill_id: skill_id,
        OldNotifyViaEmail: value,
        skillName: skillName,
      });

      dispatch(getAllSkills());
      notificationMsg('success', 'Notify via Email updated successfully.');
    } catch (error) {
      notificationMsg('error', error?.response?.data?.error ?? DEFAULT_HTTP_ERROR);
    }
  };

  // ------------ update country value ------------
  const updateCountry = (e) => {
    const old_value = option.label;
    setEditable(false);
    setOption(e);
    saveChanges(location.pathname, row.id, type, e.label, old_value, '', dispatch);
  };

  // ------------ clear options -----------
  const onClear = () => {
    selectRef?.current?.select?.clearValue();
    setOption({ value, label });
  };

  const handleOk = async () => {
    const projectById = projects?.projects?.find((pro) => pro?.id == row?.id);
    let pmId;
    if (type === 'project_manager') {
      pmId = option?.value;
    } else {
      pmId = projectById?.Employees.find((emp) => emp.EmployeeProject?.role_id == projectManagerRole?.id)?.id;
    }
    setEditable(false);
    if (option.value !== value) {
      await saveChanges(location.pathname, row.id, type, option.value, value, reason, dispatch, roles, pmId);
      // await dispatch(getProjects());
      dispatch({
        type: UPDATE_PROJECT_OPTIMISTIC,
        payload: {
          projectId: row?.id,
          updates: { projectManagerId: option.value },
        },
      });
    }
  };

  const onCancel = () => {
    setEditable(false);
    onClear();
    setReason('');
  };

  const selectInModal = (e) => {
    setOption(e);
  };

  const handleDelLim = (boolVal) => {
    setDeleteLim(boolVal);
  };

  const handleReason = (value) => {
    setReason(value.trim());
  };

  const replaceWithComponent = () => {
    return (
      <div ref={refSelectContainer}>
        <Select
          ref={selectRef}
          placeholder={`Select`}
          options={selectOptions()}
          menuPlacement="auto"
          menuPortalTarget={document.body}
          closeMenuOnScroll={(e) => {
            if (e.target.className === 'ant-table-body') {
              return true;
            } else {
              return false;
            }
          }}
          styles={customStyles}
          isSearchable={true}
          height={5}
          className="w-100"
          onChange={selectInModal}
          autoFocus={true}
        />
      </div>
    );
  };

  const title =
    (type === 'lead_sqa' && 'SQA Lead') ||
    (type === 'lead_developer' && 'Lead SW Engineer') ||
    (type === 'main_developer' && 'Main SW Engineer') ||
    (type === 'sales_team' && 'Sales Team') ||
    (type === 'project_manager' && 'Project Manager');

  return (
    <Fragment>
      {!editable ? (
        <div onMouseEnter={() => setHover(true)} onMouseLeave={() => setHover(false)}>
          {hover === true && userWritePermission?.write === true && location.pathname === '/projects' ? (
            <span>
              {label}
              <Edit
                color={themeMode === 'dark' ? '#fff' : 'black'}
                style={{
                  width: '15px',
                  marginLeft: '3px',
                  marginTop: '-2.5px',
                  cursor: 'pointer',
                }}
                onClick={() => {
                  setEditable(true);
                  setHover(false);
                  if (type !== 'sales_team') {
                    addedWithinWeek(value, row.Employees) ? (setOpenDel(true), setRemovedWithInWeek(true)) : setDeleteModalFlag(true);
                  }
                }}
              />
            </span>
          ) : hover === true && userWritePermission?.write === true && location.pathname === '/projects' ? (
            <span>
              {label}
              <Edit
                color={themeMode === 'dark' ? '#fff' : 'black'}
                style={{
                  width: '15px',
                  marginLeft: '3px',
                  marginTop: '-2.5px',
                  cursor: 'pointer',
                }}
                onClick={() => {
                  setEditable(true);
                  setHover(false);
                }}
              />
            </span>
          ) : hover === true && userWritePermission?.write === true && location.pathname === '/claim' ? (
            <span>
              <Edit
                color={themeMode === 'dark' ? '#fff' : 'black'}
                style={{
                  width: '15px',
                  marginRight: '3px',
                  marginTop: '-2.5px',
                }}
                onClick={() => {
                  setEditable(true);
                  setHover(false);
                }}
              />
              {label}
            </span>
          ) : hover === true && adminSkillsPermission?.write === true && location.pathname === '/admin/skills' ? (
            <span>
              <Edit
                color={themeMode === 'dark' ? '#fff' : 'black'}
                style={{
                  width: '15px',
                  marginRight: '3px',
                  marginTop: '-2.5px',
                }}
                onClick={() => {
                  setEditable(true);
                  setHover(false);
                }}
              />
              <span>{label}</span>
            </span>
          ) : hover === true && homePermission?.write === true && location.pathname === '/home' ? (
            <span>
              <Edit
                color={themeMode === 'dark' ? '#fff' : 'black'}
                style={{
                  width: '15px',
                  marginRight: '3px',
                  marginTop: '-2.5px',
                }}
                onClick={() => {
                  setEditable(true);
                  setHover(false);
                  if (type !== 'sales_team') {
                    addedWithinWeek(value, row.Employees) ? (setOpenDel(true), setRemovedWithInWeek(true)) : setDeleteModalFlag(true);
                  }
                }}
              />
              {label}
            </span>
          ) : location.pathname === '/email-marketing-domains' ? (
            <span style={{ display: 'flex', alignItems: 'center' }}>
              {homePermission?.write === true && hover === true && (
                <Edit
                  color={themeMode === 'dark' ? '#fff' : 'black'}
                  style={{
                    width: '15px',
                    marginRight: '10px',
                    marginTop: '-2.5px',
                  }}
                  onClick={() => {
                    setEditable(true);
                    setHover(false);
                  }}
                />
              )}
              {value ? (
                <Row className="w-100">
                  <Col xs="3">
                    <div id="avatarTooltip">
                      <Avatar alt={selectedOption?.label} src={selectedOption?.slack_avatar}>
                        {selectedOption?.label
                          ? selectedOption.label
                              .split(' ')
                              .map((n) => n[0])
                              .join('')
                          : 'N/A'}
                      </Avatar>
                    </div>
                    <Tooltip isOpen={tooltipOpen} target="avatarTooltip" toggle={toggleTooltip}>
                      {selectedOption?.label}
                    </Tooltip>
                  </Col>
                  <Col xs="9" className="pl-0 d-flex align-items-center" style={{ marginTop: 0 }}>
                    <span>{selectedOption?.label}</span>
                  </Col>
                </Row>
              ) : (
                label
              )}
            </span>
          ) : !type.isDeleted &&
            type.selectedTab !== 'REJECTED' &&
            location.pathname === '/hr-dashboard' &&
            type.leaveCreatedBy !== 'WEEKLY_SHORT_LEAVE' &&
            type.jobStatus === 'Permanent' ? (
            <span>
              <Edit
                color={themeMode === 'dark' ? '#fff' : 'black'}
                style={{
                  width: '18px',
                  marginRight: '6px',
                  marginTop: '0.5px',
                  marginBottom: '2px',
                }}
                onClick={() => {
                  setEditable(true);
                  setHover(false);
                }}
              />
              {label}
            </span>
          ) : (
            <span>{label}</span>
          )}
        </div>
      ) : (
        <>
          {type === 'lead_sqa' || type === 'lead_developer' || type === 'main_developer' ? (
            <Modal
              isOpen={true}
              backdrop={(true, 'static')}
              onOpened={() => {
                document.body.style.overflow = 'hidden';
              }}
              onClosed={() => {
                document.body.style.overflow = 'auto';
              }}
              centered={true}
              onExit={() => {
                document.body.style.overflow = 'auto';
              }}
              tered={true}
              toggle={onCancel}
            >
              <ModalHeader toggle={onCancel}>{title}</ModalHeader>
              <ModalBody>
                <div
                  ref={refSelectContainer}
                  style={{ width: '40%', display: 'flex', justifyContent: 'flex-end', marginBottom: '10px', position: 'relative' }}
                >
                  <Select
                    ref={selectRef}
                    placeholder={`Select`}
                    options={options}
                    menuPlacement="auto"
                    menuPortalTarget={document.body}
                    closeMenuOnScroll={(e) => {
                      if (e.target.className === 'ant-table-body') {
                        return true;
                      } else {
                        return false;
                      }
                    }}
                    isSearchable={true}
                    height={5}
                    className="w-100"
                    onChange={selectInModal}
                    autoFocus={true}
                  />
                </div>
                {
                  <TextAreaComponent
                    className="mb-1"
                    title="Reason For Replacing"
                    handleDelLim={handleDelLim}
                    characters={300}
                    handleReason={handleReason}
                    isDisable={!value ? true : false}
                  />
                }
              </ModalBody>
              <ModalFooter>
                <Button type="default" onClick={onCancel}>
                  Cancel
                </Button>
                <Button type="primary" disabled={reason === ''} onClick={handleOk}>
                  Ok
                </Button>
              </ModalFooter>
            </Modal>
          ) : (type === 'project_manager' && value) || (type === 'sales_team' && value && deleteModalFlag) ? (
            <React.Fragment>
              <ResourceRemarksComponent
                empName={label}
                deleteModalFlag={deleteModalFlag}
                setDeleteModalFlag={setDeleteModalFlag}
                selectManagerHandler={selectManagerHandler}
                projectManagerOptions={projectManagerOptions}
                customStyles={customStyles}
                selectInputRefss={selectInputRefss}
                selectTechnologyHandler={selectTechnologyHandler}
                skills={skills}
                communication={communication}
                setCommunication={setCommunication}
                qualityOptions={qualityOptions}
                setQuality={setQuality}
                workQuality={workQuality}
                setWorkQuality={setWorkQuality}
                reasonDetachmentOptions={reasonDetachmentOptions}
                setReasonOfDetachment={setReasonOfDetachment}
                handleDelLim={handleDelLim}
                handleReason={handleReason}
                rating={rating}
                setRating={setRating}
                emptyStates={emptyStates}
                canDeleteResource={canDeleteResource}
                deleteLim={deleteLim}
                deleteProject={deleteProject}
                empToDeleteId={value}
                projToDeleteId={row?.id}
                isDeleteLoading={isDeleteLoading}
                resetReplaceWithComponenet={onCancel}
                isPmCsmSales
                replaceWithComponent={replaceWithComponent}
              />
            </React.Fragment>
          ) : (
            <div ref={refSelectContainer} style={{ position: 'relative', width: type === 'notify_via_email' && '100px' }}>
              <Select
                sortBy={sortBy}
                sortingOrder={sortingOrder}
                trailingOptions={trailingOptions}
                placeholder={`Select`}
                value={option.label !== 'N/A' ? option : ''}
                options={options}
                menuPlacement="auto"
                maxMenuHeight={183}
                isSearchable={true}
                height={5}
                className="w-100"
                onChange={flag === true ? updateCountry : updateOption}
                onBlur={() => setEditable(false)}
                autoFocus={true}
                getPopupContainer={(trigger) => trigger.parentNode}
                menuPortalTarget={document.body}
                closeMenuOnScroll={(e) => {
                  if (e.target.className === 'ant-table-body') {
                    return true;
                  } else {
                    return false;
                  }
                }}
              />
            </div>
          )}
        </>
      )}
      {openDel && (
        <WarningModal
          title="Confirmation"
          message={`Are you sure you want to replace ${capitalizeEachFirstLetter(type)} from project?`}
          visible={openDel}
          replaceWithComponent={replaceWithComponent}
          onCancel={() => {
            setOpenDel(false);
            onCancel();
          }}
          onOk={() => {
            deleteProject(value, row?.id);
          }}
          disableOnOk={option?.value === value}
          // disableOnOk={isDeleteLoading}
        />
      )}

      <CommonModal
        open={confirmationModal}
        setModal={() => {
          // Uncomment and use the setters as needed
          setConfirmationModal(false);
          setSelectedRow(null);
          setProjectBillingData(null);
          setCurrentStepIndex(0);
          setAddMilestones([{ description: '', dueDate: '', amount: '' }]);
        }}
        projectName={row?.name}
        body={wizardBody}
        footer={wizardFooterEditSubModal}
        width={900}
      />

      <CommonModal
        open={statusReasonsModal}
        setModal={() => {
          setStatusReasonsModal(false);
          setCloseReason(null);
        }}
        projectName={row?.name}
        body={bodyStatusReasonModal}
        footer={footerEditSubModal}
        width={500}
      />

      <CommonModal
        open={milestonesModal}
        setModal={() => {
          // Uncomment and use the setters as needed
          // setMilestonesModal(false);
          handleClose();
        }}
        projectName="Add Milestones"
        body={milestones}
        footer={footerEditSubModal}
        width={800}
      />
    </Fragment>
  );
};

// ------------- projects exist validation ------------
export function projectExists(name, projects) {
  return projects?.projects?.some(function (el) {
    return el?.name?.toLowerCase().replace(/\s+/g, '') === name?.toLowerCase().replace(/\s+/g, '');
  });
}

// billing channel options
export const billingChannelOptions = [
  { value: 'INVOZONE_PVT_LTD_MEEZAN', label: 'IZ Pvt. Ltd. Meezan' },
  // { value: 'INVOZONE_AOP_MEEZAN', label: 'IZ AOP Meezan' },
  // { value: 'INVOZONE_AOP_STD_CHART', label: 'IZ AOP Std Chart' },
  // { value: 'INVOZONE_SOLE_MEEZAN', label: 'InvoZone Sole Meezan' },
  // { value: 'INVOZONE_CIMB_MALAYSIA', label: 'InvoZone CIMB Malaysia' },
  // { value: 'INVOZONE_RHB_MALAYSIA', label: 'InvoZone RHB Malaysia' },
  // { value: 'FURQAN_AZIZ_MAYBANK', label: 'Furqan Aziz Maybank' },
  { value: 'FURQAN_AZIZ_PAYPAL', label: 'Furqan Aziz Paypal' },
  { value: 'FURQAN_AZIZ_WISE', label: 'Furqan Aziz Wise' },
  { value: 'PAYONEER_ACCOUNT', label: 'Payoneer Account' },
  { value: 'UPWORK_PROFILE', label: 'Upwork Profile' },
  // { value: 'DEEL_CONTRACT', label: 'Deel Contract' },
  // { value: 'WESTERN_UNION', label: 'Western Union' },
  { value: 'CASH_IN_HAND', label: 'Cash In Hand' },
];
